<template>
  <div class="relative">
    <h1
      class="flex flex-col items-center space-y-16 text-center font-medium md:space-y-20 lg:space-y-24 xl:space-y-28"
    >
      <span
        class="type-font-salt-ss02 text-[30px]/[1.1em] font-medium md:text-[50px]/[1.1em] xl:text-[60px]/[1.1em]"
        >wait! for more</span
      >
      <span class="large-text type-font-salt-ss02 -rotate-[2deg] text-charcoal"
        ><span>thrills</span></span
      >
    </h1>
    <div class="icons pointer-events-none absolute inset-0">
      <PayloadIcon
        class="absolute -left-[0.3em] bottom-[0.2em] h-[0.35em] text-yellow-light"
        icon="SvgIconFirework"
      />
      <PayloadIcon
        class="absolute bottom-[0.7em] left-[0.7em] h-[0.35em] text-purple"
        icon="SvgIconSurfboardAlt"
      />
      <PayloadIcon
        class="absolute bottom-[0.6em] left-[2.55em] h-[0.35em] rotate-[60deg] text-red-light"
        icon="SvgIconShockA"
      />
      <PayloadIcon
        class="absolute -bottom-[0.3em] left-[1.7em] h-[0.3em] rotate-[22deg] text-yellow-light"
        icon="SvgIconShootingStar"
      />
    </div>
  </div>
</template>

<style scoped lang="postcss">
span {
  @apply inline-block;
}
</style>
